require('./angular-animate');
module.exports = 'ngAnimate';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-animate/index.js
 ** module id = 351
 ** module chunks = 0
 **/